import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=1aa21d80&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=1aa21d80&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa21d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa21d80')) {
      api.createRecord('1aa21d80', component.options)
    } else {
      api.reload('1aa21d80', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=1aa21d80&scoped=true", function () {
      api.rerender('1aa21d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/OrderDetail.vue"
export default component.exports